module.exports = __webpack_public_path__ + "img/Yotta-Logo_dark.c328d8.svg";